@if (project) {
  <ul class="field-list">
    <li>
      <label><nb-icon icon="percent-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.vat_option' | translate" [attr.aria-label]="'invoicing.explain.vat_option' | translate">{{ 'invoicing.project.vat_option' | translate }}</span><span class="required">*</span></label>
      <nb-select id="project-vat_option" [attr.aria-label]="'invoicing.project.vat_option' | translate" size="small" [status]="errors.VatOption_id ? 'danger' : 'basic'" [(selected)]="project.VatOption_id" [placeholder]="'invoicing.project.no_vat_option' | translate">
        <nb-option [value]="null">{{ 'invoicing.project.no_vat_option' | translate }}</nb-option>
        @for (option of options; track option.id) {
          <nb-option [value]="option.id">{{ option.kind === 'reverse_charge' ? ('invoicing.vat.reverse_charge' | translate) : ('invoicing.vat.rate' | translate:{value: option.rate}) }}</nb-option>
        }
      </nb-select>
      @if (error('VatOption_id'); as message) { <span class="error">{{ message }}</span> }
    </li>
    <li>
      <label><nb-icon icon="hash-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.client_reference' | translate" [attr.aria-label]="'invoicing.explain.client_reference' | translate">{{ 'invoicing.project.client_reference' | translate }}</span></label>
      <input id="project-client_reference" nbInput [attr.aria-label]="'invoicing.project.client_reference' | translate" fieldSize="small" maxlength="100" [(ngModel)]="project.client_reference">
    </li>
    <li>
      <label><nb-icon icon="car-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.project_km_price' | translate" [attr.aria-label]="'invoicing.explain.project_km_price' | translate">{{ 'invoicing.km.price' | translate }}</span></label>
      <span class="with-unit">
        <input nbInput [attr.aria-label]="'invoicing.km.price' | translate" fieldSize="small" inputmode="decimal" [placeholder]="decimal('0.23')" [disabled]="project.travel_not_chargeable" [status]="errors.km_price ? 'danger' : 'basic'" [ngModel]="decimal(project.km_price)" (ngModelChange)="project.km_price = $event">
        <span class="unit">{{ 'invoicing.km.per_km' | translate }}</span>
      </span>
      @if (error('km_price'); as message) { <span class="error">{{ message }}</span> }
    </li>
    <li>
      <label><nb-icon icon="slash-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.travel_not_chargeable' | translate" [attr.aria-label]="'invoicing.explain.travel_not_chargeable' | translate">{{ 'invoicing.project.travel' | translate }}</span></label>
      <nb-checkbox [(ngModel)]="project.travel_not_chargeable">{{ 'invoicing.project.travel_not_chargeable' | translate }}</nb-checkbox>
    </li>
  </ul>
  @if (project.missing?.length) {
    <div class="readiness">
      <nb-icon icon="alert-triangle-outline" status="warning"></nb-icon>
      <div>
        <span>{{ 'invoicing.project.missing' | translate }}</span>
        <ul>@for (field of project.missing; track field) { <li>{{ 'invoicing.missing.' + field | translate }}</li> }</ul>
      </div>
    </div>
  } @else {
    <div class="readiness"><nb-icon icon="checkmark-circle-2-outline" status="success"></nb-icon><span>{{ 'invoicing.project.ready' | translate }}</span></div>
  }
  @if (defaultRate; as d) {
    <div class="readiness"><nb-icon icon="alert-triangle-outline" status="warning"></nb-icon><span>{{ 'invoicing.project.default_rate' | translate:d }}</span></div>
  }
  <div class="actions">
    <span class="hint"><span class="required">*</span> {{ 'invoicing.required' | translate }}</span>
    <button nbButton size="small" status="primary" [disabled]="busy" (click)="save()"><nb-icon icon="checkmark"></nb-icon><span>{{ 'save' | translate }}</span></button>
  </div>
}
